// extracted by mini-css-extract-plugin
export default {"cont":"placeorder_cont__0JIJt","box":"placeorder_box__OrNjW","head":"placeorder_head__FCg5q","btn":"placeorder_btn__aVFK9","imag":"placeorder_imag__7MAUM"};